import Image from 'next/image';
import topupdated from '../../../../public/topupatednew.webp';
import clutch from '../../../../public/clutupdatednew.webp';
import batch from '../../../../public/credit_batch.webp';
import dungs from '../../../../public/dungsnew.webp';
import esomar from '../../../../public/ESOMAR_member_RGB-17.webp';
import { PriceCard } from './price-card';
import { RadioGroup } from '@/components/ui/radio-group';
import { usePathname, useRouter } from '@/i18n/routing';
import { useContext, useEffect } from 'react';
import { ReportContext } from '@/app/providers/reportProvider';
import { useTranslations } from 'next-intl';

export default function InstantAccess({
  orderAmount,
  setOrderAmount,
  setLicenceType,
}) {
  //Navigation
  const pathName = usePathname();
  const router = useRouter();
  const report = useContext(ReportContext);
  const t = useTranslations('lead_magnet');
  const regionalText_1 = useTranslations('request_sample.get_instant_acc');

  const prices = [
    // {
    //   price: '400',
    //   title: 'Executive Summary',
    //   id: 'r1',
    //   tooltip_content:
    //     'Top market findings and snapshot by all segments (Statistics)',
    // },
    {
      price: 2000,
      title: t('license_type.excel_databook'),
      id: 'r2',
      tooltip_content: t('tooltips.T2'),
    },
    {
      price: report.Price_SUL,
      title: t('license_type.SUL'),
      id: 'r3',
      tooltip_content: t('tooltips.T3'),
    },
    {
      price: report.Price_Multi,
      title: t('license_type.MUL'),
      id: 'r4',
      tooltip_content: t('tooltips.T4'),
    },
    {
      price: report.Price_CUL,
      title: t('license_type.CUL'),
      id: 'r5',
      tooltip_content: t('tooltips.T5'),
    },
  ];

  return (
    <>
      <div className="flex flex-col space-y-4 justify-center">
        <div>
          <h2 className="text-white font-16 font-bold pt-3">
            {t('license_type.title')}
          </h2>
        </div>
        <div>
          <RadioGroup
            defaultValue={report.Price_Multi}
            onValueChange={(value) => {
              setOrderAmount(value);
              if (value === report.Price_SUL) {
                setLicenceType(regionalText_1('license_type.SUL'));
              } else if (value === report.Price_Multi) {
                setLicenceType(regionalText_1('license_type.MUL'));
              } else if (value === report.Price_CUL) {
                setLicenceType(regionalText_1('license_type.CUL'));
              } else if (value === 2000) {
                setLicenceType(regionalText_1('license_type.excel_databook'));
              }
            }}
            className="grid grid-cols-6 grid-rows-1 gap-3 lg:grid-cols-4 lg:gap-4 lg:mx-20 mx-10 items-center"
          >
            {prices.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`bg-white rounded-lg font-13 font-semibold text-black flex-1 border-t-8 shadow-2xl h-full lg:col-span-1 col-span-2 
                    ${
                      orderAmount === item.price
                        ? 'border-t-orange-400'
                        : 'border-t-white'
                    }${index === 3 ? ' col-start-3 col-end-5' : ''}`}
                >
                  <PriceCard
                    price={item.price}
                    title={item.title}
                    id={item.id}
                    tooltipContent={item.tooltip_content}
                    fullReport={t('license_type.full_report')}
                  />
                </div>
              );
            })}
          </RadioGroup>
        </div>
        <div className="text-center w-full">
          <button
            className="p-2 rounded-md bg-gradient-to-r from-orange-500 to-pink-500 font-13 font-semibold text-white cursor-pointer"
            title="Buy Now"
            onClick={() => router.push(`${pathName}/buynow`)}
          >
            {t('license_type.buy_now')}
          </button>
        </div>
        <div className="flex flex-row justify-evenly items-center">
          <div className="border border-white border-dashed w-1/3 h-0"></div>
          <div>
            <Image
              src={batch}
              className="img-fluid"
              alt="Credibility and Certifications"
              title="Credibility and Certifications"
              sizes="100vw"
              style={{
                width: '30px',
                height: 'auto',
              }}
            />
          </div>
          <div className="border border-white border-dashed w-1/3 h-0"></div>
        </div>
        <div>
          <p className="text-white font-16 font-bold">
            {t('license_type.credibility_certification')}
          </p>
        </div>
        <div className="mt-1">
          <div className="flex gap-x-1 lg:gap-x-3 justify-center mb-4">
            <div className="text-center relative">
              <Image
                src={dungs}
                className="img-fluid"
                alt="Credibility and Certifications"
                title="Credibility and Certifications"
                style={{
                  width: '100px',
                  height: 'auto',
                }}
              />
              <span className="text-white text-[10px] lg:text-sm absolute start-4 -mt-px">
                860519526
              </span>
            </div>
            <Image
              src={esomar}
              className="img-fluid"
              alt="Esomar-2024"
              title="Esomar-2024"
              sizes="100vw"
              style={{
                width: '100px',
                height: 'auto',
              }}
            />
            <Image
              src={clutch}
              className="img-fluid"
              alt="Clutch"
              title="Clutch"
              sizes="100vw"
              style={{
                width: '100px',
                height: 'auto',
              }}
            />
            <Image
              src={topupdated}
              className="img-fluid"
              alt="Top Market Research Agency"
              title="Top Market Research Agency"
              sizes="100vw"
              style={{
                width: '100px',
                height: 'auto',
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
